import React, { useEffect, useState } from 'react';
import { useLocation, Navigate, useNavigate  } from 'react-router-dom';
import { sessionTokenLogin, logout } from '../../modules/login';

const SessionTokenLogin = () => { 

    const navigate = useNavigate();

    const [success, setSuccess] = useState<boolean>(false);

    const qp = useLocation().search;
    const token = new URLSearchParams(qp).get('Token');

    if (!token) {
        return <Navigate to={'/login'}/>;
    }

    useEffect(() => {
        if (success) {
            navigate('/');
        }
    }, [success]);

    useEffect(() => {

        const login = async() => {
            try {
                await logout();
                await sessionTokenLogin(token);
                setSuccess(true);
            } catch(e) {
                navigate('/login');
            } 
        };

        login();
    }, []);

    return (
       <>
            <h4>Logging in...</h4>
        </>
        
    );
};

export default SessionTokenLogin;